import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonDataService } from '../../common-data.service';

@Component({
  selector: 'app-roster-teams-panel',
  templateUrl: './roster-teams-panel.component.html',
  styleUrls: ['./roster-teams-panel.component.scss'],
  host: { 'class': 'roster-right-panel' }
})
export class RosterTeamsPanelComponent {

  // ── View state ──
  @Input() gridHirView: string = 'grid';
  @Input() collapse_expand_All: boolean = false;
  @Input() hirarchicalgridData: any[] = [];
  @Input() memViewTeam: any;

  // ── Team data ──
  @Input() teams: any[];
  @Input() teamsMeta: any;
  @Input() allTeamIdsTtl: any[] = [];
  @Input() defaultShowingMembers: number = 5;
  @Input() teamLoaders: { [key: string]: boolean } = {};
  @Input() isDemoRoster: boolean = false;
  @Input() teamID: any;

  // ── Pagination ──
  @Input() teamsPerPage: number = 20;
  @Input() teamMemberCurrentPg: number = 1;
  @Input() memberCurrentPg: number = 1;

  // ── Search ──
  @Input() teamSrchName: string;
  @Input() teamSrchBy: string = 'name';

  // ── Misc display ──
  @Input() rosterName: string;
  @Input() filterData: any;
  @Input() loading: any;
  @Input() orgId: any;
  @Input() demoRosterId: string;

  // ── Report/PDF ──
  @Input() selectedGroupProfileTeamsArr: any[] = [];
  @Input() slectedIndividualTeamArr: any[] = [];
  @Input() mockupReportArgs: any;
  @Input() mockupReportArgsArr: any[] = [];
  @Input() openPdfPopup: boolean = false;

  // ── Toolbar outputs ──
  @Output() viewChange = new EventEmitter<string>();
  @Output() searchTeam = new EventEmitter<any>();
  @Output() cancelSearch = new EventEmitter<void>();
  @Output() newTeam = new EventEmitter<void>();
  @Output() teamSrchNameChange = new EventEmitter<string>();
  @Output() searchMembers = new EventEmitter<any>();
  @Output() cancelSrchTeamMember = new EventEmitter<void>();
  @Output() hierarchicalView = new EventEmitter<void>();
  @Output() accordToggle = new EventEmitter<MouseEvent>();
  @Output() teamCardAccordToggle = new EventEmitter<{ className: string; event: MouseEvent }>();
  @Output() updateFilter = new EventEmitter<any>();
  @Output() searchRoasterReset = new EventEmitter<void>();
  @Output() openPdfPopupChange = new EventEmitter<boolean>();
  @Output() mockupReportArgsChange = new EventEmitter<any>();
  @Output() deleteSelectedTeams = new EventEmitter<void>();
  @Output() downloadCsv = new EventEmitter<string>();

  // ── Team card outputs ──
  @Output() selectedGroupProfileTeamsChange = new EventEmitter<any>();
  @Output() participantView = new EventEmitter<{ from: string; team: any; member: any }>();
  @Output() openCloseTeamPopup = new EventEmitter<{ open: boolean; teamId: string; teamName: string }>();
  @Output() deleteTeam = new EventEmitter<{ team: any; index: number }>();
  @Output() collapseExpandAll = new EventEmitter<MouseEvent>();
  @Output() removeTeamMember = new EventEmitter<any>(); // from team-card: {member, team}
  @Output() removeTeamMemberFromDirectory = new EventEmitter<any>(); // from directory-view: member directly
  @Output() additionalTeamPopup = new EventEmitter<any>();
  @Output() mkTeamLead = new EventEmitter<{ member: any; roleId: any; team: any }>();
  @Output() loadMore = new EventEmitter<{ teamId: string; roaster: number; allMembers: boolean }>();
  @Output() memberGoToProfile = new EventEmitter<any>();

  // ── Directory view outputs ──
  @Output() directoryOpenSideBar = new EventEmitter<any>();
  @Output() refreshTeams = new EventEmitter<void>();
  @Output() dirViewChange = new EventEmitter<string>();
  @Output() removeRosterMem = new EventEmitter<{ item: any; index: number; type: string; teamIndex: number }>();
  @Output() teamsChange = new EventEmitter<any[]>();

  // ── Pagination outputs ──
  @Output() pageChange = new EventEmitter<number>();
  @Output() teamsPerPageChange = new EventEmitter<number>(); // emits new value

  constructor(public CommonDataService: CommonDataService) {}
}
